// extracted by mini-css-extract-plugin
export default {"button":"button--ifmbl","disabled":"disabled--GbdDa","withIcon":"withIcon--YRoyq","icon":"icon--fwvn3","label":"label--ZafYV","redBtn":"redBtn--Pjee1"};